import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { SidebarItem, SidebarNestedSection } from "./sidebarTypes";
import {
  Home,
  FolderKanban,
  BriefcaseBusiness,
  Plus,
  Eye,
  UserSearch,
  ContactRound,
  Wallet,
  Library,
  ClipboardList,
  GraduationCap,
  BookOpen,
  File,
  FileText,
  FileCode,
  Book,
  Folder,
  Database,
  Coffee,
  UserPen,
  Stars,
} from "lucide-react";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const userSidebarContent: SidebarItem[] = [
  {
    link: "/",
    Icon: Home,
    title: "Home",
  },
  {
    link: "/view-attendance",
    Icon: UserSearch,
    title: "Attendance",
  },
  {
    link: "/resource",
    Icon: File,
    title: "Resources",
  },
  {
    link: "/lectures",
    Icon: Eye,
    title: "Lectures",
  },
  {
    link: "/projects",
    Icon: FolderKanban,
    title: "Projects",
  },
  {
    link: "/add-portfolio",
    Icon: BriefcaseBusiness,
    title: "Portfolio",
  },
  {
    link: "/ranking",
    Icon: GraduationCap,
    title: "Ranking",
  },
  {
    link: "/interview",
    Icon: Stars,
    title: "Interview",
  }
];
export const InstructorSidebarContent: SidebarItem[] = [
  {
    link: "/",
    Icon: Home,
    title: "Home",
  },
  {
    link: "/students",
    Icon: GraduationCap,
    title: "Students",
  },
  {
    link: "/resource",
    Icon: File,
    title: "Resources",
  },
  {
    link: "/lectures",
    Icon: Eye,
    title: "Lectures",
  },
  {
    link: "/projects",
    Icon: FolderKanban,
    title: "projects",
  },
  {
    link: "/attendance",
    Icon: ContactRound,
    title: "Attendance",
  },
  {
    link: "/courses",
    Icon: Library,
    title: "View-courses",
  },
  {
    link: "/batch",
    Icon: BookOpen,
    title: "Batch",
  },
];

export const userSidebarNested: SidebarNestedSection[] = [];

// HR Routes
export const HRSidebarContent: SidebarItem[] = [
  {
    link: "/",
    Icon: Home,
    title: "Dashboard",
  },
  {
    link: "/attendance",
    Icon: ContactRound,
    title: "Attendance",
  },
  {
    link: "/view-fee",
    Icon: Wallet,
    title: "View-Fees",
  },
  {
    link: "/courses",
    Icon: Library,
    title: "View-courses",
  },
  {
    link: "/batch",
    Icon: BookOpen,
    title: "Batch",
  },
  {
    link: "/enquiry",
    Icon: ClipboardList,
    title: "Enquiry",
  },
];

export const HRSidebarNested: SidebarNestedSection[] = [
  {
    header: "Students",
    icon: GraduationCap,
    items: [
      { href: "/students", text: "Students list", icon: Eye },
      { href: "student/add-student", text: "Add Student", icon: Plus },
    ],
  },
];

export const AdminSidebarContent: SidebarItem[] = [
  {
    link: "/",
    Icon: Home,
    title: "Dashboard",
  },
  {
    link: "/students",
    Icon: GraduationCap,
    title: "Students",
  },
  {
    link: "/view-fee",
    Icon: Wallet,
    title: "Fees",
  },
  {
    link: "/courses",
    Icon: BookOpen,
    title: "Courses",
  },
  {
    link: "/batch",
    Icon: FolderKanban,
    title: "Batch",
  },
  {
    link: "/enquiry",
    Icon: ClipboardList,
    title: "Enquiry",
  },
  {
    link: "/attendance",
    Icon: UserSearch,
    title: "Attendance",
  },
  {
    link: "/expenses",
    Icon: BriefcaseBusiness,
    title: "Expenses",
  },
  {
    link: "/register",
    Icon: UserPen,
    title: "HR Staff",
  },
  {
    link: "/instructorStaff",
    Icon: UserPen,
    title: "Instructor Staff",
  },
];

export const RESOURCES_STATIC_DATA = [
  {
    title: "Resume Template",
    icon: FileText,
    description: "Professional resume templates in multiple formats",
    downloadUrl: "../assets/resume.pdf",
    type: "Document",
  },
  {
    title: "Code Samples",
    icon: FileCode,
    description: "Ready-to-use code snippets and examples",
    downloadUrl: "#",
    type: "Code",
  },
  {
    title: "Study Material",
    icon: Book,
    description: "Complete study guides and references",
    downloadUrl: "#",
    type: "Education",
  },
  {
    title: "Project Templates",
    icon: Folder,
    description: "Starter templates for your projects",
    downloadUrl: "#",
    type: "Template",
  },
  {
    title: "Resource Pack",
    icon: Database,
    description: "Comprehensive resource collection",
    downloadUrl: "#",
    type: "Resources",
  },
  {
    title: "Quick Start Guide",
    icon: Coffee,
    description: "Get started with our quick guide",
    downloadUrl: "#",
    type: "Guide",
  },
];

export const getYoutubeId = (url: string) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
  const match = url?.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};
